<template>
  <div class="home">
    <v-img :src="require('@/assets/images/personnel.jpg')">

    </v-img>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.commit('SET_BREADCRUMBS', []);
  },
}
</script>